import { LeftOutlined } from '@ant-design/icons';
import { pushToLink } from '../../utils/helpers/global';
import { routeConstant } from '../../constants/app.constants';
import headerLogo from '../../assets/HomePage/headerLogo.svg';
import expired from '../../assets/expired.svg';
import styles from './styles.module.scss';
import { GradientButton } from '../../components/GradientButton/GradientButton';

const ResetPasswordExpired = (props) => {
  const goToForgotPassword = () => {
    pushToLink(props.history, routeConstant.FORGOT_PASSWORD_PATH);
  };

  const goToLogin = () => {
    pushToLink(props.history, routeConstant.USER_LOGIN_PATH);
  };

  return (
    <div className={styles.container_}>
      <div>
        <img src={headerLogo} alt="Header logo" className={styles.headerLogo} />
        <div>
          <p>Reset link expired</p>
        </div>
        <div>
          This password reset link is no longer valid. Please generate a new password reset link to
          continue.
        </div>
        <div>
          <img src={expired} alt="Expired link" className={styles.linkSentImg} />
        </div>
        <div className={styles.formbox}>
          <GradientButton htmlType="button" onClick={goToForgotPassword}>
            Generate New Link
          </GradientButton>
        </div>
        <div onClick={goToLogin} className={styles.backToLogin}>
          <LeftOutlined style={{ color: 'var(--link-text-color)', marginRight: '5px' }} />
          <span>Back to login</span>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordExpired;
